// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-rilevazione {
  color: var(--color-primary);
}

.grid-rilevazione-filled {
  background-color: var(--color-primary);
  color: white;
}

.radiomodlezione {
  vertical-align: text-bottom;
  margin-right: 2px;
}

.wcenter {
  text-align: center;
}

.wleft {
  text-align: left;
}

.hcenter {
  align-self: center;
}

.text-big {
  font-size: 1.5rem;
}

.text-medium {
  font-size: 1.2rem;
}

.display-contents {
  display: contents;
}

.separatore {
  border-right-color: var(--color-primary);
  border-right-style: solid;
}

.separatore-white {
  border-right-color: white;
  border-right-style: solid;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/radar-ril-viewer/radar-ril-viewer.component.scss"],"names":[],"mappings":"AACA;EACI,2BAAA;AAAJ;;AAGA;EACI,sCAAA;EACA,YAAA;AAAJ;;AAGA;EACI,2BAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,kBAAA;AAAJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AACA;EACI,iBAAA;AAEJ;;AAAA;EACI,iBAAA;AAGJ;;AAAA;EACI,iBAAA;AAGJ;;AAAA;EACI,wCAAA;EACA,yBAAA;AAGJ;;AAAA;EACI,yBAAA;EACA,yBAAA;AAGJ","sourcesContent":["\n.grid-rilevazione {\n    color: var(--color-primary); \n}\n\n.grid-rilevazione-filled {\n    background-color: var(--color-primary); \n    color: white;\n}\n\n.radiomodlezione {\n    vertical-align: text-bottom;\n    margin-right: 2px;\n}\n\n.wcenter {\n    text-align: center;\n}\n.wleft {\n    text-align: left;\n}\n\n.hcenter {\n    align-self:center;\n}\n.text-big {\n    font-size: 1.5rem;\n}\n.text-medium {\n    font-size: 1.2rem;\n}\n\n.display-contents {\n    display: contents;\n}\n\n.separatore {\n    border-right-color: var(--color-primary); \n    border-right-style: solid;\n}\n\n.separatore-white {\n    border-right-color: white; \n    border-right-style: solid;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
